<template>
  <div>
    <div class="row">
      <div class="col-md-9">
        <common-panel title="My Booking">
          <flight-search-module @search="search" :dateStart="searchDateStart" :showStatus="true" :stations="OD" />
        </common-panel>
      </div>
      <div class="col-md-3">
        <side-bar />
      </div>
    </div>
    <div>
      <div v-for="(bookings, groupKey, groupIndex) in bookingGroups" :key="groupIndex">
        <h2>{{ groupKey }}</h2>
        <div class="row">
          <booking-card :booking="b" v-for="(b, bookingIndex) of bookings" :key="bookingIndex" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import images from "../core/images";
import { groupBy } from "../core/tools";
import { mapState, mapActions } from "vuex";
import FlightSearchModule from "@/modules/FlightSearch";
import BookingCard from "@/components/card/BookingCard";
import CommonPanel from "@/components/layout/CommonPanel";
import { stdFromJourneys, transformBookings } from "../core/staff-helper";
//import { flightStatus } from "../core/enum";

export default {
  components: {
    CommonPanel,
    BookingCard,
    FlightSearchModule,
  },
  data() {
    return {
      status: null,
      origin: null,
      destination: null,
      bookingDateEnd: null,
      bookingDateStart: null,
      departureStation: "TPE",
      // 顯示用的 booking
      bookingGroups: [],
    };
  },
  methods: {
    async search(info) {
      try {
        const dateEnd = info.bookingDateEnd ? moment(info.bookingDateEnd).add(1, "days").format("YYYY-MM-DD") : undefined;
        const bookings = await this.getBookings({
          flightStatus: info.status,
          flightOrigin: info.origin1,
          flightDestination: info.destination1,
          bookingDate_end: dateEnd,
          bookingDate_start: info.bookingDateStart,

          page: 1,
          pageSize: 100,
        });

        this.bookingGroups = groupBy(transformBookings(bookings, false), (b) => {
          let d = stdFromJourneys(b.journeys);
          return d && d.getFullYear ? `${d.getFullYear()}/${d.getMonth() + 1}` : "Cancelled";
        });
      } catch (ex) {
        this.setMessagePopup({
          title: this.$text.errorMessageTitle,
          message: ex?.response?.data?.Description ?? ex.message
        });
      }
    },
    ...mapActions(["getBookings", "setMessagePopup"]),
  },
  computed: {
    images: () => images,
    searchDateStart: () => moment().add(-3, "days").format("YYYY-MM-DD"),
    ...mapState({
      OD: (s) => {
        let obj = {};
        Object.entries(s.OD).forEach(
          (x) => (obj[x[0]] = Object.entries(x[1]).map((y) => y[1]))
        );
        return obj;
      },
      stations: (s) => {
        let obj = {};
        Object.keys(s.OD).forEach((c) =>
          Object.keys(s.OD[c]).forEach(
            (x) => (obj[s.OD[c][x].code] = s.OD[c][x])
          )
        );
        return obj;
      },
    }),
  },
};
</script>